import React from "react";
import {Link} from "react-router-dom";
import EditBook from "../../img/EditBook.png";
import PDF from "../../img/PDF.png";
import HTML from "../../img/HTML.png";
import StartReading from "../../img/StartReading.png";
import axios from "axios";
import {chBlRecViewed} from "./action/books";
import {connect} from "react-redux";
// import {Accordion, Card} from "react-bootstrap";

class ABookListPage extends React.Component{
    constructor(props) {
      super(props);
    
      this.state = {
        "ov": false,
        loading: false
      };
    }
    componentDidMount(){
        if(this.props.match.params.bookId){
        axios.defaults.headers.common['bookid'] = this.props.match.params.bookId;
        if(this.props.chBlRecViewed){
            var date = new Date();
            var toSend = date.getDate()+date.getMonth()+date.getFullYear()+date.getHours()+date.getMinutes();
            this.props.chBlRecViewed(toSend)
        }}
    }
    render(){
        const {bookId} = this.props.match.params;
        window.onscroll = function() {scrollFunction()};
        var scrollFunction = () => {
            if (document.body.scrollTop > 1 || document.documentElement.scrollTop > 3) {
                this.setState({"ov": true});
            }else{
                this.setState({"ov": false});
            }
        }
        return(
            <div>
                <div className="aBooklPage">
                {!this.state.loading && this.props.bookLists ? (
                        <div className="left">
                        <div id="top">
                            <div id="content">
                                <h1> {this.props.bookLists[this.props.match.params.bookId].booklist_title} </h1>
                                <Link to={"/main/editBookL/"+this.props.match.params.bookId}><img src={EditBook} alt="Edit Book" className="editBookIconBookList" /></Link>
                                <h3> {this.props.bookLists[this.props.match.params.bookId].booklist_description} </h3>
                            </div>
                        </div><br/><br/>
                        <div className="booksInTheBooklistTop">
                            <h1> Books in this Booklist</h1>
                        </div>
                            {this.props.books && this.props.books.map(function(item){
                                console.log(item.inTheBookList)
                                if(item.inTheBookList.includes(parseInt(bookId))){
                                    return <BookAccordion item = {item} />
                                }
                            })}
                    </div>
                    
                    ):<div className="loader">
                        <div></div>
                        <h1>Please Wait...</h1>
                    </div>}
                </div>
            </div>
        );
    }
};

const BookAccordion = (props) => {
    return (
                <Link className="h3 bookAcordian" to={"/main/books/"+props.item.bookId}>{props.item.book_title}</Link>

        )
}

const Book = (props) => {
    return(
        <div className="book">
        <Link to={"/main/books/"+props.bookId} className="pagalHain">
            <div>
                <img src={"/root/user/"+localStorage.BookAppLogin+"/"+props.imageSrc} alt="Book_COver" className="book_cover"/>
            </div>
            <div className="rightSection">
                <h2 className="book_title p">{props.title}</h2>
                <div className="total_section">
                    <h6>Total Chapters: <b>{props.chapters}</b></h6>
                    <h6>Total Pages: <b>{props.pages}</b></h6>
                </div>
                <p className="description">{props.description.substring(0, 95)} {props.description.length > 94 && (<span className="text-danger"><b><u>Read More...</u></b></span>)}</p>
            </div>
            <div className="type">
                {(props.type === "PDF") ? <img src={PDF} alt="PDF" className="PDF"/>:<img src={HTML} alt="HTML" className="HTML"/>}
            </div>
        </Link>
            <div className="footerleft">
                <Link to={"/main/editBook/"+props.type+"/"+props.bookId}><img src={EditBook} alt="Edit Book" className="editBook" /></Link>
            </div>

            <Link to={"/main/books/readBook"+props.type+"/"+props.bookId} className="footerright">
                <img src={StartReading} alt="Start Reading" className="sr" />
            </Link>
            </div>
    )
};

function mapStateToProps (state) {
    return {bookLists: state.AllBooklists.bookLists, totalBooklists: state.user.totalBooklists, books: state.AllBooks.books}
}

export default connect(mapStateToProps, {chBlRecViewed})(ABookListPage);